import { useFormikContext, FastField, Field } from 'formik';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { FormField, Textarea } from '@shipengine/formik-giger';
import { useTranslation } from '@packlink/translation-provider';
import { FormikCountrySelector, FormikPostalCodeSelector } from '@packlink/address-selectors';
import { FieldNames } from './InvoiceForm.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useAddressValues } from '../contexts/addressValues.js';
import { useDisabledFields } from '../contexts/disabledFields.js';

const InvoiceAddressForm = () => {
  var _values$country5;
  const sdk = useSdk();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    isFieldDisabled
  } = useDisabledFields();
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    setSelectedCountry,
    setSelectedPostalCode
  } = useAddressValues();

  /**
   * Some users (old ones) only have alpha2Code but not the state property
   * In order to fix this, let's fill the Country (alpha2Code and state)
   */
  useEffectOnce(() => {
    (async () => {
      var _values$country, _values$country2;
      if (values !== null && values !== void 0 && (_values$country = values.country) !== null && _values$country !== void 0 && _values$country.value && !(values !== null && values !== void 0 && (_values$country2 = values.country) !== null && _values$country2 !== void 0 && _values$country2.label)) {
        const countries = await sdk.v1.locations.countries.all({
          language: i18n.language
        });
        const country = countries.find(country => {
          var _values$country3;
          return country.alpha2Code === ((_values$country3 = values.country) === null || _values$country3 === void 0 ? void 0 : _values$country3.value);
        });
        setFieldValue(FieldNames.COUNTRY, {
          value: country === null || country === void 0 ? void 0 : country.alpha2Code,
          label: country === null || country === void 0 ? void 0 : country.name
        });
      }
    })();
  });
  const handleOnChangeCountrySelector = (_name, value, country) => {
    var _values$country4;
    setSelectedCountry(country);

    /**
     * Reset PostalCode field.
     */
    if ((value === null || value === void 0 ? void 0 : value.value) !== ((_values$country4 = values.country) === null || _values$country4 === void 0 ? void 0 : _values$country4.value)) {
      setFieldValue(FieldNames.POSTALCODE, '');
    }
  };
  const handleOnChangePostalCodeSelector = (name, value, postalCode) => {
    setSelectedPostalCode(postalCode);
    setFieldValue(name, value);
  };
  const onCountryLoaded = country => {
    if (!country) {
      setFieldValue(FieldNames.COUNTRY, '');
    }
    setSelectedCountry(country);
  };
  const onPostalCodeLoaded = postal => {
    if (!postal) {
      setFieldValue(FieldNames.POSTALCODE, '');
    }
    setSelectedPostalCode(postal);
  };
  return jsxs("div", {
    "aria-label": "address-info",
    children: [jsx(FormField, {
      name: FieldNames.ADDRESS,
      children: jsx(FastField, {
        disabled: isFieldDisabled(FieldNames.ADDRESS),
        component: Textarea,
        label: t(`invoice-form.label.${FieldNames.ADDRESS}`)
      })
    }), jsx(FastField, {
      disabled: isFieldDisabled(FieldNames.COUNTRY),
      component: FormikCountrySelector,
      label: t('invoice-form.label.country'),
      name: FieldNames.COUNTRY,
      onLoad: onCountryLoaded,
      onChange: handleOnChangeCountrySelector
    }), jsx(Field, {
      alpha2Code: (_values$country5 = values.country) === null || _values$country5 === void 0 ? void 0 : _values$country5.value,
      component: FormikPostalCodeSelector,
      disabled: isFieldDisabled(FieldNames.POSTALCODE),
      name: FieldNames.POSTALCODE,
      onLoad: onPostalCodeLoaded,
      onChange: handleOnChangePostalCodeSelector
    })]
  });
};
var InvoiceAddressForm$1 = InvoiceAddressForm;

export { InvoiceAddressForm$1 as default };
//# sourceMappingURL=InvoiceAddressForm.js.map
